import { loadStripe } from "@stripe/stripe-js";
import api from "../axios/axiosInstance";

export const stripePromise = api.get("/config")
  .then((res) => {
    const key = res.data?.stripePublishableKey;
    if (!key) {
      console.error("[Stripe] publishable key missing from /config response");
      return null;
    }
    return loadStripe(key);
  })
  .catch((err) => {
    console.error("[Stripe] failed to load config:", err.message);
    return null;
  });
